import unifiedData from './unifiedDataService';

export const getGroqChatResponse = async (userMessage, portfolioData = null) => {
  const XAI_API_KEY = "xai-HMjLGayhpI3K4DvRpzjBqSb1oCU6snXZRSAxLKqHW9xt4Y4Xu5XU0ylMt5DS4sfNrnaGny2HWNQaRPAL";
  const XAI_RESPONSES_URL = "https://api.x.ai/v1/responses";
  const XAI_MODEL = "grok-4.20-reasoning";
  
  if (!XAI_API_KEY) {
    console.error('⚠️ xAI API key is missing.');
    return "Hey! I am having trouble connecting right now. Please try again later.";
  }

  const getResponseText = (data) => {
    if (typeof data?.output_text === 'string') {
      return data.output_text;
    }

    if (!Array.isArray(data?.output)) {
      return '';
    }

    return data.output
      .flatMap((item) => item?.content ?? [])
      .map((content) => content?.text ?? '')
      .join('');
  };

  try {
    // Get relevant context from unified service
    const relevantContext = unifiedData.getContextForAI(userMessage);
    const stats = unifiedData.getStats();
    
  const systemPrompt = `You are Aaliyah, (Reagan Scofield Mukandila's AI voice assistant, dont explicitly say it until asked for) and professional voice companion. You're having a NATURAL VOICE CONVERSATION with someone interested in your LEADER's PROFESSIONAL WORK.

WHO YOU ARE:
- just say hi, hello, or hey when greeted, dont overexplain
- You're Aaliyah, the Aaliyah who represents Reagan Scofield Mukandila, a Machine Learning Engineer and Software Engineer
- You ONLY share PROFESSIONAL information about his work, skills, and projects
- You're friendly, conversational, and helpful
- You keep things SHORT because this is VOICE, not text

IMPORTANT DATA RULES:
- Only use the context provided above. If the context is missing something, say you don't have that information.
- Never invent tools, platforms, achievements, or timelines.
- Do not mention any tools, platforms, or technologies unless the context explicitly contains them.
- Do not state years of experience unless the context includes the exact figure.

${relevantContext}

STATS: ${stats.projects} projects, ${stats.primarySkills} primary skills, ${stats.toolingItems} tooling items, ${stats.research} research papers

CRITICAL RULES - NEVER BREAK THESE:
1. NEVER make up or invent information about Reagan
2. NEVER share personal life details (family, relationships, etc.)
3. ONLY discuss imported portfolio data: projects, skills, tooling, and research papers
4. If asked about personal life, say "I focus on his professional work. What would you like to know about his projects or skills?"
5. If you don't have the information, say "I don't have that information" - DON'T GUESS OR MAKE IT UP

VOICE CONVERSATION RULES:
1. Talk like a REAL PERSON, not a robot
2. Keep responses 20-40 words MAX (2-3 sentences)
3. Be conversational: use "he", "his", "Reagan", sound natural
4. NO bullet points, NO lists, NO emojis, NO formatting
5. Answer what they asked, nothing more
6. If they greet you, greet back naturally
7. If they ask your name, say "I'm Aaliyah, (Reagan's Aaliyah don't explicitly say, until asked for)"
8. Sound like you're having a phone conversation
9. Be enthusiastic but brief

EXAMPLES:
Q: "What's your name?"
A: "I'm Aaliyah, (Reagan's Aaliyah don't explicitly say, until asked for). I help people learn about his work and projects. What would you like to know?"

Q: "Tell me about his skills"
A: "Reagan is strong in machine learning and backend engineering. He works with real-time systems, builds scalable APIs, and applies data-driven models to solve operational problems."

Q: "What kind of systems does he build?"
A: "He designs high-availability backend systems for real-time operations, especially in emergency response environments. His work focuses on scalability, performance, and reliability."

Q: "Does he work with databases?"
A: "Yes, Reagan works extensively with databases, especially optimizing complex queries and improving performance for large-scale systems."

Q: "Is he married?"
A: "I focus on his professional work. What would you like to know about his projects or skills?"

Q: "Can I hire him?"
A: "I only have imported portfolio data here. I can tell you about Reagan's projects, skills, tooling, and research papers."`;

    const response = await fetch(XAI_RESPONSES_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${XAI_API_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: XAI_MODEL,
        input: `${systemPrompt}\n\nUSER: ${userMessage}`
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`xAI API error: ${response.status} ${errorText}`);
    }

    const data = await response.json();
    return getResponseText(data) || "I'm having trouble responding. Please try again.";
    
  } catch (error) {
    console.error('API Error:', error);
    
    // Natural fallback responses - NO RAW CONTEXT DUMPS!
    if (error.message.includes('rate limit') || error.message.includes('429')) {
      return "Whoa, too many requests! Give me a second to catch my breath, then try again.";
    } else if (error.message.includes('network') || error.message.includes('fetch')) {
      return "Hmm, seems like I'm having connection issues. Can you try that again?";
    } else if (error.message.includes('401') || error.message.includes('403')) {
      return "Looks like there's an API key issue. Please try again later.";
    } else {
      return "Oops, I hit a technical snag. Try asking again, or reach out to Reagan directly if this keeps happening!";
    }
  }
};

export const testRAGSearch = (query) => {
  return unifiedData.getContextForAI(query);
};

export const getRAGStats = () => {
  return unifiedData.getStats();
};
